import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';

type UserActionMenuProps<T> = {
  entity: T;
  handleActionClick: (e: T) => void;
};

export const ActionCellMenu = <T extends { code: string }>({
  entity,
  handleActionClick,
}: UserActionMenuProps<T>) => (
  <Dropdown
    placement="bottom"
    menu={{
      items: [
        {
          key: 'custom-action-0',
          label: 'View',
          onClick: () => handleActionClick(entity),
        },
      ],
    }}
    trigger={['click']}
  >
    <EllipsisOutlined rotate={90} />
  </Dropdown>
);
